import { defineTextStyles } from "@chakra-ui/react";

export const textStyles = defineTextStyles({
  body: {
    regular: {
      value: {
        fontFamily: "body",
        fontWeight: "400",
        fontSize: "lg",
        lineHeight: "24px",
        letterSpacing: "0",
      },
    },
    semibold: {
      value: {
        fontFamily: "body",
        fontWeight: "600",
        fontSize: "lg",
        lineHeight: "24px",
        letterSpacing: "0",
      },
    },
    bold: {
      value: {
        fontFamily: "body",
        fontWeight: "700",
        fontSize: "lg",
        lineHeight: "24px",
        letterSpacing: "0",
      },
    },
    underlined: {
      value: {
        fontFamily: "body",
        fontWeight: "400",
        fontSize: "lg",
        lineHeight: "24px",
        letterSpacing: "0",
        textDecoration: "underline",
        textDecorationStyle: "solid",
      },
    },
    small: {
      value: {
        fontFamily: "body",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "0",
      },
    },
    smallSemibold: {
      value: {
        fontFamily: "body",
        fontWeight: "600",
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "0",
      },
    },
  },
  badge: {
    value: {
      fontFamily: "body",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "0",
      textTransform: "uppercase",
    },
  },
  button: {
    value: {
      fontFamily: "body",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "0",
    },
  },
  helpText: {
    value: {
      fontFamily: "body",
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0",
    },
  },
  errorMessage: {
    value: {
      color: "error.500",
      fontFamily: "body",
      fontWeight: "600",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0",
    },
  },
  tableColumnHeader: {
    value: {
      fontFamily: "body",
      fontWeight: "600",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0",
    },
  },
  cardHeadingLink: {
    value: {
      fontFamily: "body",
      fontWeight: "600",
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0",
      textDecoration: "underline",
      textDecorationStyle: "solid",
    },
  },
  largeText: {
    1: {
      value: {
        fontFamily: "heading",
        fontWeight: "700",
        fontSize: "48px",
        lineHeight: "56px",
        letterSpacing: "0",
      },
    },
  },
  lead: {
    value: {
      fontFamily: "body",
      fontWeight: "400",
      fontSize: "2xl",
      lineHeight: "32px",
      letterSpacing: "0",
    },
  },
  link: {
    standard: {
      value: {
        fontFamily: "body",
        fontWeight: "400",
        fontSize: "lg",
        lineHeight: "24px",
        letterSpacing: "0",
        textDecoration: "underline",
        textDecorationStyle: "solid",
      },
    },
    button: {
      value: {
        fontFamily: "body",
        fontWeight: "400",
        fontSize: "md",
        lineHeight: "24px",
        letterSpacing: "0",
        textDecoration: "underline",
        textDecorationStyle: "solid",
      },
    },
    buttonSmall: {
      value: {
        fontFamily: "body",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "0",
        textDecoration: "underline",
        textDecorationStyle: "solid",
      },
    },
  },
  formLabel: {
    value: {
      color: "textBlack.800",
      fontFamily: "body",
      fontWeight: "600",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0",
    },
  },
  heading: {
    h1: {
      value: {
        fontFamily: "heading",
        fontWeight: "700",
        fontSize: "40px",
        lineHeight: "64px",
        letterSpacing: "0",
      },
    },
    h2: {
      value: {
        fontFamily: "heading",
        fontWeight: "600",
        fontSize: "30px",
        lineHeight: "40px",
        letterSpacing: "0",
      },
    },
    h3: {
      value: {
        fontFamily: "heading",
        fontWeight: "600",
        fontSize: "24px",
        lineHeight: "32px",
        letterSpacing: "0",
      },
    },
    h4: {
      value: {
        fontFamily: "heading",
        fontWeight: "600",
        fontSize: "20px",
        lineHeight: "32px",
        letterSpacing: "0",
      },
    },
    h5: {
      value: {
        color: "textBlack.800",
        fontFamily: "heading",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0",
      },
    },
  },
});
